module.exports = __webpack_public_path__ + "media/compress_video.286ff411.webm";